import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
    integrations: [],
}

export const integrationSlice = createSlice({
    name: 'integration',
    initialState,
    reducers: {
        setIntegrations: (state, action) => {
            state.integrations = action.payload
        },
    },
})

export const { setIntegrations } = integrationSlice.actions

export default integrationSlice.reducer
